import type { ModelData } from '../../types'

export const dragonNarozne: { [key: string]: ModelData } = {
  'dragon-2b-slim': {
    id: 'dragon-2b-slim',
    name: 'DRAGON 2B SLIM',
    power: '8 kW',
    type: 'powietrzny',
    glassType: 'narozna' as const,
    image: 'images/dragon-2b-slim.jpg',
    emailSubject: 'Zapytanie - DRAGON 2B SLIM',
    description: 'Wkład powietrzny narożny 8 kW',
    basePrices: {
      standard: {
        single: 9310,
        'single-connected': 10380,
        double: 11450,
        'double-connected': 12520
      },
      lift: {
        single: 12950,
        'single-connected': 14020,
        double: 15090,
        'double-connected': 16160
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 600,
          'flush-30': 690,
          'recessed-15': 790,
          'recessed-30': 900,
          'recessed-15-45': 990
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 730,
          'recessed-lift-30': 850,
          'recessed-lift-5': 1600
        }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Szyba dzielona x1', 
        'single-connected': 'Szyba gięta x1',
        'double': 'Szyba dzielona x2',
        'double-connected': 'Szyba gięta x2'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    specs: {
      power: '8 kW',
      efficiency: '77,0%',
      energyClass: 'A',
      glassSize: '681+336 x 471 mm',
      insertSize: '702 x 1168-1307 x 400 mm',
      fireplaceSize: '445 x 500 x 234 mm',
      maxLogLength: '490 mm',
      weight: '160 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4B SLIM',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4B SLIM w konfiguracji:\n\nModel: DRAGON 4B SLIM\nMoc: 14 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },

  'dragon-2b': {
    id: 'dragon-2b',
    name: 'DRAGON 2B',
    power: '13 kW',
    type: 'powietrzny',
    glassType: 'narozna' as const,
    image: 'images/dragon-2b.jpg',
    emailSubject: 'Zapytanie - DRAGON 2B',
    description: 'Wkład powietrzny narożny 8 kW',
    basePrices: {
      standard: {
        single: 9420,
        'single-connected': 10490,
        double: 11560,
        'double-connected': 12630
      },
      lift: {
        single: 13060,
        'single-connected': 14130,
        double: 15200,
        'double-connected': 16270
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 600,
          'flush-30': 690,
          'recessed-15': 790,
          'recessed-30': 900,
          'recessed-15-45': 990
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 730,
          'recessed-lift-30': 850,
          'recessed-lift-5': 1600
        }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      }
        },
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Szyba dzielona x1', 
        'single-connected': 'Szyba gięta x1',
        'double': 'Szyba dzielona x2',
        'double-connected': 'Szyba gięta x2'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      }
    },
    specs: {
      power: '13 kW',
      efficiency: '77,0%',
      energyClass: 'A',
      glassSize: '681+336 x 471 mm',
      insertSize: '681 x 1129-1284 x 462 mm',
      fireplaceSize: '445 x 500 x 254 mm',
      maxLogLength: '490 mm',
      weight: '174 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 2B',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 2B w konfiguracji:\n\nModel: DRAGON 2B\nMoc: 13 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  'dragon-2b-xl': {
  id: 'dragon-2b-xl',
  name: 'DRAGON 2B XL',
  power: '8 kW',
  type: 'powietrzny',
  glassType: 'narozna' as const,
  image: 'images/dragon-2b-xl.jpg',
  emailSubject: 'Zapytanie - DRAGON 2B XL',
  description: 'Wkład powietrzny narożny 8 kW',
  basePrices: {
    standard: {
      single: 9630
    },
    lift: {
      single: 13270
    }
  },
  extraPrices: {
    ceramic: { 
      'refrabox-light': 0, 
      'cerabox-graphite': 0 
    },
    handle: { 
      'classic-black': 0, 
      'classic-silver': 0,
      'design-black': 0,
      'design-black-silver': 0
    },
    bezel: {
      standard: { 
        none: 0, 
        'flush-15': 650,
        'flush-30': 740,
        'recessed-15': 850,
        'recessed-30': 970,
        'recessed-15-45': 1050
      },
      lift: { 
        none: 0, 
        'recessed-lift-15': 780,
        'recessed-lift-30': 890,
        'recessed-lift-5': 1680
      }
    },
    fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
    thermalModules: { 
      'none': 0, 
      'thermal': 260
    }
  },
  labels: {
    variant: { 
      'standard': 'Standard', 
      'lift': 'LIFT'
    },
    glass: { 
      'single': 'Szyba dzielona x1'
    },
    ceramic: { 
      'refrabox-light': 'Jasna Refrabox', 
      'cerabox-graphite': 'Grafitowa Cerabox' 
    },
    handle: { 
      'classic-black': 'Classic czarna', 
      'classic-silver': 'Classic srebrna',
      'design-black': 'Design czarna',
      'design-black-silver': 'Design czarno-srebrna'
    },
    bezel: { 
      'none': 'Bez blendy', 
      'flush-15': 'Licująca 15mm (R15)',
      'flush-30': 'Licująca 30mm (R30)',
      'recessed-15': 'Zagłębiająca 15mm (RZ15)',
      'recessed-30': 'Zagłębiająca 30mm (RZ30)',
      'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
      'recessed-lift-30': 'LIFT 30mm (RL30)',
      'recessed-lift-5': 'LIFT 5mm (RL05)'
    },
    fusion: { 
      'none': 'Brak',
      'fusion': 'FUSION',
      'fusion-modules': 'FUSION MODULES'
    },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
    thermalModules: {
      'none': 'Brak',
      'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
    }
  },
  specs: {
    power: '8 kW',
    efficiency: '77,0%',
    energyClass: 'A',
    glassSize: '681+336 x 514 mm',
    insertSize: '702 x 1172-1327 x 462 mm',
    fireplaceSize: '488 x 500 x 254 mm',
    maxLogLength: '490 mm',
    weight: '160 kg'
  },
  emailTemplate: {
    subject: 'Zapytanie - DRAGON 2B XL',
    body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 2B XL w konfiguracji:\n\nModel: DRAGON 2B XL\nMoc: 9 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
  }
},

  'dragon-4b-slim': {
    id: 'dragon-4b-slim',
    name: 'DRAGON 4B SLIM',
    power: '14 kW',
    type: 'powietrzny',
    glassType: 'narozna' as const,
    image: 'images/dragon-4b-slim.jpg',
    emailSubject: 'Zapytanie - DRAGON 4B SLIM',
    description: 'Wkład powietrzny narożny 14 kW',
    basePrices: {
      standard: {
        single: 10920,
        'single-connected': 12200,
        double: 13700,
        'double-connected': 14980
      },
      lift: {
        single: 14660,
        'single-connected': 15950,
        double: 17450,
        'double-connected': 18730
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 680,
          'flush-30': 780,
          'recessed-15': 870,
          'recessed-30': 1000,
          'recessed-15-45': 1100
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 820,
          'recessed-lift-30': 950,
          'recessed-lift-5': 1780
        }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      }
    },
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Szyba dzielona x1', 
        'single-connected': 'Szyba gięta x1',
        'double': 'Szyba dzielona x2',
        'double-connected': 'Szyba gięta x2'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      }
    },
    specs: {
      power: '14 kW',
      efficiency: '78,0%',
      energyClass: 'A',
      glassSize: '762+420 x 471 mm',
      insertSize: '807 x 1114-1269 x 489 mm',
      fireplaceSize: '438 x 605 x 285 mm',
      maxLogLength: '580 mm',
      weight: '191 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4B SLIM',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4B SLIM w konfiguracji:\n\nModel: DRAGON 4B SLIM\nMoc: 14 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },

'dragon-4b-xl-slim': {
  id: 'dragon-4b-xl-slim',
  name: 'DRAGON 4B XL SLIM',
  power: '14 kW',
  type: 'powietrzny',
  glassType: 'narozna' as const,
  image: 'images/dragon-4b-xl-slim.jpg',
  emailSubject: 'Zapytanie - DRAGON 4B XL SLIM',
  description: 'Wkład powietrzny narożny 13 kW',
  basePrices: {
    standard: {
      single: 11240
    },
    lift: {
      single: 14980
    }
  },
  extraPrices: {
    ceramic: { 
      'refrabox-light': 0, 
      'cerabox-graphite': 0 
    },
    handle: { 
      'classic-black': 0, 
      'classic-silver': 0,
      'design-black': 0,
      'design-black-silver': 0
    },
    bezel: {
      standard: { 
        none: 0, 
        'flush-15': 690,
        'flush-30': 790,
        'recessed-15': 900,
        'recessed-30': 1040,
        'recessed-15-45': 1130
      },
      lift: { 
        none: 0, 
        'recessed-lift-15': 830,
        'recessed-lift-30': 960,
        'recessed-lift-5': 1810
      }
    },
    fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
    thermalModules: { 
      'none': 0, 
      'thermal': 260
    }
  },
  labels: {
    variant: { 
      'standard': 'Standard', 
      'lift': 'LIFT'
    },
    glass: { 
      'single': 'Szyba dzielona x1'
    },
    ceramic: { 
      'refrabox-light': 'Jasna Refrabox', 
      'cerabox-graphite': 'Grafitowa Cerabox' 
    },
    handle: { 
      'classic-black': 'Classic czarna', 
      'classic-silver': 'Classic srebrna',
      'design-black': 'Design czarna',
      'design-black-silver': 'Design czarno-srebrna'
    },
    bezel: { 
      'none': 'Bez blendy', 
      'flush-15': 'Licująca 15mm (R15)',
      'flush-30': 'Licująca 30mm (R30)',
      'recessed-15': 'Zagłębiająca 15mm (RZ15)',
      'recessed-30': 'Zagłębiająca 30mm (RZ30)',
      'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
      'recessed-lift-15': 'LIFT 15mm (RL15)',
      'recessed-lift-30': 'LIFT 30mm (RL30)',
      'recessed-lift-5': 'LIFT 5mm (RL05)'
    },
    fusion: { 
      'none': 'Brak',
      'fusion': 'FUSION',
      'fusion-modules': 'FUSION MODULES'
    },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
    thermalModules: {
      'none': 'Brak',
      'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
    }
  },
  specs: {
    power: '14 kW',
    efficiency: '78,4%',
    energyClass: 'A',
    glassSize: '762+420 x 514 mm',
    insertSize: '807 x 1157-1312 x 489 mm',
    fireplaceSize: '480 x 605 x 285 mm',
    maxLogLength: '600 mm',
    weight: '198 kg'
  },
  emailTemplate: {
    subject: 'Zapytanie - DRAGON 4B XL SLIM',
    body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4B XL SLIM w konfiguracji:\n\nModel: DRAGON 4B XL SLIM\nMoc: 13 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
  }
},


  'dragon-4b': {
    id: 'dragon-4b',
    name: 'DRAGON 4B',
    power: '15,5 kW',
    type: 'powietrzny',
    glassType: 'narozna' as const,
    image: 'images/dragon-4b.jpg',
    emailSubject: 'Zapytanie - DRAGON 4B',
    description: 'Wkład powietrzny narożny z systemem podnoszenia szyby 12 kW',
    basePrices: {
      standard: {
        single: 11080,
        'single-connected': 12360,
        double: 13860,
        'double-connected': 15150
      },
      lift: {
        single: 14820,
        'single-connected': 16110,
        double: 17610,
        'double-connected': 18890
      }
    },
    extraPrices: {
      ceramic: { 
        'refrabox-light': 0, 
        'cerabox-graphite': 0 
      },
      handle: { 
        'classic-black': 0, 
        'classic-silver': 0,
        'design-black': 0,
        'design-black-silver': 0
      },
      bezel: {
        standard: { 
          none: 0, 
          'flush-15': 680,
          'flush-30': 780,
          'recessed-15': 870,
          'recessed-30': 1000,
          'recessed-15-45': 1100
        },
        lift: { 
          none: 0, 
          'recessed-lift-15': 820,
          'recessed-lift-30': 950,
          'recessed-lift-5': 1780
        }
      },
      fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
      thermalModules: { 
        'none': 0, 
        'thermal': 260
      }
        },
    labels: {
      variant: { 
        'standard': 'Standard', 
        'lift': 'LIFT'
      },
      glass: { 
        'single': 'Szyba dzielona x1', 
        'single-connected': 'Szyba gięta x1',
        'double': 'Szyba dzielona x2',
        'double-connected': 'Szyba gięta x2'
      },
      ceramic: { 
        'refrabox-light': 'Jasna Refrabox', 
        'cerabox-graphite': 'Grafitowa Cerabox' 
      },
      handle: { 
        'classic-black': 'Classic czarna', 
        'classic-silver': 'Classic srebrna',
        'design-black': 'Design czarna',
        'design-black-silver': 'Design czarno-srebrna'
      },
      bezel: { 
        'none': 'Bez blendy', 
        'flush-15': 'Licująca 15mm (R15)',
        'flush-30': 'Licująca 30mm (R30)',
        'recessed-15': 'Zagłębiająca 15mm (RZ15)',
        'recessed-30': 'Zagłębiająca 30mm (RZ30)',
        'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
        'recessed-lift-15': 'LIFT 15mm (RL15)',
        'recessed-lift-30': 'LIFT 30mm (RL30)',
        'recessed-lift-5': 'LIFT 5mm (RL05)'
      },
      fusion: { 
        'none': 'Brak',
        'fusion': 'FUSION',
        'fusion-modules': 'FUSION MODULES'
      },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
      thermalModules: {
        'none': 'Brak',
        'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
      }
    },
    specs: {
      power: '15,5 kW',
      efficiency: '78,6%',
      energyClass: 'A',
      glassSize: '762+420 x 471 mm',
      insertSize: '762 x 1114-1269 x 574 mm',
      fireplaceSize: '438 x 580 x 370 mm',
      maxLogLength: '570 mm',
      weight: '207 kg'
    },
    emailTemplate: {
      subject: 'Zapytanie - DRAGON 4B',
      body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4B w konfiguracji:\n\nModel: DRAGON 4B\nMoc: 12 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
    }
  },
  
'dragon-4b-xl': {
  id: 'dragon-4b-xl',
  name: 'DRAGON 4B XL',
  power: '15,5 kW',
  type: 'powietrzny',
  glassType: 'narozna' as const,
  image: 'images/dragon-4b-xl.jpg',
  emailSubject: 'Zapytanie - DRAGON 4B XL',
  description: 'Wkład powietrzny narożny 15 kW',
  basePrices: {
    standard: {
      single: 11400
    },
    lift: {
      single: 15150
    }
  },
  extraPrices: {
    ceramic: { 
      'refrabox-light': 0, 
      'cerabox-graphite': 0 
    },
    handle: { 
      'classic-black': 0, 
      'classic-silver': 0,
      'design-black': 0,
      'design-black-silver': 0
    },
    bezel: {
      standard: { 
        none: 0, 
        'flush-15': 690,
        'flush-30': 790,
        'recessed-15': 900,
        'recessed-30': 1040,
        'recessed-15-45': 1130
      },
      lift: { 
        none: 0, 
        'recessed-lift-15': 830,
        'recessed-lift-30': 960,
        'recessed-lift-5': 1810
      }
    },
    fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
    thermalModules: { 
      'none': 0, 
      'thermal': 260
    }
  },
  labels: {
    variant: { 
      'standard': 'Standard', 
      'lift': 'LIFT'
    },
    glass: { 
      'single': 'Szyba dzielona x1'
    },
    ceramic: { 
      'refrabox-light': 'Jasna Refrabox', 
      'cerabox-graphite': 'Grafitowa Cerabox' 
    },
    handle: { 
      'classic-black': 'Classic czarna', 
      'classic-silver': 'Classic srebrna',
      'design-black': 'Design czarna',
      'design-black-silver': 'Design czarno-srebrna'
    },
    bezel: { 
      'none': 'Bez blendy', 
      'flush-15': 'Licująca 15mm (R15)',
      'flush-30': 'Licująca 30mm (R30)',
      'recessed-15': 'Zagłębiająca 15mm (RZ15)',
      'recessed-30': 'Zagłębiająca 30mm (RZ30)',
      'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
      'recessed-lift-15': 'LIFT 15mm (RL15)',
      'recessed-lift-30': 'LIFT 30mm (RL30)',
      'recessed-lift-5': 'LIFT 5mm (RL05)'
    },
      fusion: { 
      'none': 'Brak',
      'fusion': 'FUSION',
      'fusion-modules': 'FUSION MODULES'
    },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
    thermalModules: {
      'none': 'Brak',
      'thermal': 'MODUŁ 600/370/80 mm (34,5 kg)'
    }
  },
  specs: {
    power: '15,5 kW',
    efficiency: '78,6%',
    energyClass: 'A',
    glassSize: '762+420 x 514 mm',
    insertSize: '770 x 1157-1312 x 574 mm',
    fireplaceSize: '480 x 580 x 370 mm',
    maxLogLength: '570 mm',
    weight: '213 kg'
  },
  emailTemplate: {
    subject: 'Zapytanie - DRAGON 4B XL',
    body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 4B XL w konfiguracji:\n\nModel: DRAGON 4B XL\nMoc: 15 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
  }
},

'dragon-8b': {
  id: 'dragon-8b',
  name: 'DRAGON 8B',
  power: '11,5 kW',
  type: 'powietrzny',
  glassType: 'narozna' as const,
  image: 'images/dragon-8b.jpg',
  emailSubject: 'Zapytanie - DRAGON 8B',
  description: 'Wkład powietrzny narożny 10 kW',
  basePrices: {
    standard: {
      single: 8240
    },
    lift: {
      single: 11770
    }
  },
  extraPrices: {
    ceramic: { 
      'refrabox-light': 0, 
      'cerabox-graphite': 0 
    },
    handle: { 
      'classic-black': 0, 
      'classic-silver': 0,
      'design-black': 0,
      'design-black-silver': 0
    },
    bezel: {
      standard: { 
        none: 0, 
        'flush-15': 590,
        'flush-30': 680,
        'recessed-15': 780,
        'recessed-30': 890,
        'recessed-15-45': 970
      },
      lift: { 
        none: 0, 
        'recessed-lift-30': 820,
        'recessed-lift-5': 1550
      }
    },
    fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
    thermalModules: { 
      'none': 0, 
      'thermal': 235
    }
  },
  labels: {
    variant: { 
      'standard': 'Standard', 
      'lift': 'LIFT'
    },
    glass: { 
      'single': 'Szyba dzielona x1'
    },
    ceramic: { 
      'refrabox-light': 'Jasna Refrabox', 
      'cerabox-graphite': 'Grafitowa Cerabox' 
    },
    handle: { 
      'classic-black': 'Classic czarna', 
      'classic-silver': 'Classic srebrna',
      'design-black': 'Design czarna',
      'design-black-silver': 'Design czarno-srebrna'
    },
    bezel: { 
      'none': 'Bez blendy', 
      'flush-15': 'Licująca 15mm (R15)',
      'flush-30': 'Licująca 30mm (R30)',
      'recessed-15': 'Zagłębiająca 15mm (RZ15)',
      'recessed-30': 'Zagłębiająca 30mm (RZ30)',
      'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
      'recessed-lift-30': 'LIFT 30mm (RL30)',
      'recessed-lift-5': 'LIFT 5mm (RL05)'
    },
    fusion: { 
      'none': 'Brak',
      'fusion': 'FUSION',
      'fusion-modules': 'FUSION MODULES'
    },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
    thermalModules: {
      'none': 'Brak',
      'thermal': 'MODUŁ 370/370/80 mm (21 kg)'
    }
  },
  specs: {
    power: '11,5 kW',
    efficiency: '75,0%',
    energyClass: 'A',
    glassSize: '452+452 x 514 mm',
    insertSize: '469 x 1314-1390 x 469 mm',
    fireplaceSize: '495 x 312 x 312 mm',
    maxLogLength: '290 mm',
    weight: '126 kg'
  },
  emailTemplate: {
    subject: 'Zapytanie - DRAGON 8B',
    body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 8B w konfiguracji:\n\nModel: DRAGON 8B\nMoc: 10 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
  }
},

    
'dragon-8b-xxl': {
  id: 'dragon-8b-xxl',
  name: 'DRAGON 8B XXL',
  power: '13,7 kW',
  type: 'powietrzny',
  glassType: 'narozna' as const,
  image: 'images/dragon-8b-xxl.jpg',
  emailSubject: 'Zapytanie - DRAGON 8B XXL',
  description: 'Wkład powietrzny narożny 13 kW',
  basePrices: {
    standard: {
      single: 9420
    },
    lift: {
      single: 13060
    }
  },
  extraPrices: {
    ceramic: { 
      'refrabox-light': 0, 
      'cerabox-graphite': 0 
    },
    handle: { 
      'classic-black': 0, 
      'classic-silver': 0,
      'design-black': 0,
      'design-black-silver': 0
    },
    bezel: {
      standard: { 
        none: 0, 
        'flush-15': 670,
        'flush-30': 760,
        'recessed-15': 860,
        'recessed-30': 990,
        'recessed-15-45': 1070
      },
      lift: { 
        none: 0, 
        'recessed-lift-15': 790,
        'recessed-lift-30': 900,
        'recessed-lift-5': 1720
      }
    },
    fusion: { none: 0, fusion: 500, 'fusion-modules': 200 },
      controllers: {
        'none': 0,
        'czujnik-drzwiczek': 215,
        'rt-08-om': 1510,
        'rt-08-om-grafik': 1610,
        'rt-08-om-grafik-wb': 1745,
        'rt-08-om-duo-integra': 2170,
        'rt-08-om-grafik-duo-integra': 2200,
        'rt-08-om-grafik-duo-integra-wb': 2300
      },
    thermalModules: { 
      'none': 0, 
      'thermal': 235
    }
  },
  labels: {
    variant: { 
      'standard': 'Standard', 
      'lift': 'LIFT'
    },
    glass: { 
      'single': 'Szyba dzielona x1'
    },
    ceramic: { 
      'refrabox-light': 'Jasna Refrabox', 
      'cerabox-graphite': 'Grafitowa Cerabox' 
    },
    handle: { 
      'classic-black': 'Classic czarna', 
      'classic-silver': 'Classic srebrna',
      'design-black': 'Design czarna',
      'design-black-silver': 'Design czarno-srebrna'
    },
    bezel: { 
      'none': 'Bez blendy', 
      'flush-15': 'Licująca 15mm (R15)',
      'flush-30': 'Licująca 30mm (R30)',
      'recessed-15': 'Zagłębiająca 15mm (RZ15)',
      'recessed-30': 'Zagłębiająca 30mm (RZ30)',
      'recessed-15-45': 'Zagłębiająca 15mm 45° (RZ45)',
      'recessed-lift-15': 'LIFT 15mm (RL15)',
      'recessed-lift-30': 'LIFT 30mm (RL30)',
      'recessed-lift-5': 'LIFT 5mm (RL05)'
    },
    fusion: { 
      'none': 'Brak',
      'fusion': 'FUSION',
      'fusion-modules': 'FUSION MODULES'
    },
      controllers: {
        'none': 'Brak',
        'czujnik-drzwiczek': 'Czujnik drzwiczek',
        'rt-08-om': 'RT-08 OM',
        'rt-08-om-grafik': 'RT-08 OM GRAFIK',
        'rt-08-om-grafik-wb': 'RT-08 OM GRAFIK WHITE / BLACK',
        'rt-08-om-duo-integra': 'RT-08 OM DUO INTEGRA',
        'rt-08-om-grafik-duo-integra': 'RT-08 OM GRAFIK DUO INTEGRA',
        'rt-08-om-grafik-duo-integra-wb': 'RT-08 OM GRAFIK DUO INTEGRA WHITE / BLACK'
      },
    thermalModules: {
      'none': 'Brak',
      'thermal': 'MODUŁ 370/370/80 mm (21 kg)'
    }
  },
  specs: {
    power: '13,7 kW',
    efficiency: '79,9%',
    energyClass: 'A',
    glassSize: '452+452 x 684 mm',
    insertSize: '469 x 1484-1560 x 469 mm',
    fireplaceSize: '665 x 312 x 312 mm',
    maxLogLength: '290 mm',
    weight: '147 kg'
  },
  emailTemplate: {
    subject: 'Zapytanie - DRAGON 8B XXL',
    body: 'Dzień dobry,\n\nProszę o wycenę wkładu kominkowego DRAGON 8B XXL w konfiguracji:\n\nModel: DRAGON 8B XXL\nMoc: 13 kW\nKonfiguracją: [KONFIGURACJA]\nCena: [CENA] zł netto\n\nPozdrawiam'
  }
 }
}



